import { render } from "./proposal-page.vue?vue&type=template&id=13c9922a&scoped=true"
import script from "./proposal-page.vue?vue&type=script&lang=js"
export * from "./proposal-page.vue?vue&type=script&lang=js"

import "./proposal-page.vue?vue&type=style&index=0&id=13c9922a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c9922a"]])

export default __exports__